import moment from 'moment';

/*
  Véhicules du jour (SPE Rungis, feature VEHICLES_OF_THE_DAY des affectations
  camion) : tous les camions sont disponibles par défaut, le dispatcher marque
  ceux qui ne le sont pas à une date. Ces règles ne s'appliquent que lorsque la feature est activée.
*/

/** États d'un camion à une date (eligibility_status de l'API). */
export const ELIGIBILITY = {
  ELIGIBLE: 'ELIGIBLE',
  UNAVAILABLE: 'UNAVAILABLE',
  DISABLED: 'DISABLED',
  ARCHIVED: 'ARCHIVED',
};

/** Nombre maximal de jours posés en une demande (MAX_UNAVAILABILITY_DATES de l'API). */
export const MAX_UNAVAILABILITY_DAYS = 62;

/**
 * Le camion est-il proposé à l'affectation ce jour ? Un camion sans état
 * (réponse d'une API sans la feature) est disponible.
 */
export const isTruckAssignable = (truck) =>
  !truck?.eligibilityStatus || truck.eligibilityStatus === ELIGIBILITY.ELIGIBLE;

/**
 * Pourquoi le camion n'est pas proposé ce jour, en quelques mots
 *
 * @returns {string|null} - null pour un camion disponible
 */
export const describeTruckUnavailability = (truck) => {
  switch (truck?.eligibilityStatus) {
    case ELIGIBILITY.UNAVAILABLE:
      return truck.unavailabilityReason
        ? `Indisponible ce jour · ${truck.unavailabilityReason}`
        : 'Indisponible ce jour';
    case ELIGIBILITY.DISABLED:
      return "Retiré de l'affectation depuis sa fiche véhicule";
    case ELIGIBILITY.ARCHIVED:
      return 'Véhicule archivé';
    default:
      return null;
  }
};

/**
 * Camions proposés dans la modale d'affectation : les disponibles du jour, et
 * le camion actuel des commandes (affiché, mais non sélectionnable)
 */
export const getAssignableTrucks = (trucks, targets) =>
  trucks.filter(
    (truck) =>
      isTruckAssignable(truck) ||
      (targets || []).some((delivery) => delivery.vehicleId === truck.id)
  );

/** Les camions indisponibles du jour passent en fin de liste, l'ordre restant celui des clés. */
export const sortTrucksOfTheDay = (trucks) =>
  [...trucks].sort(
    (a, b) => Number(!isTruckAssignable(a)) - Number(!isTruckAssignable(b))
  );

/**
 * Les jours d'une indisponibilité, du premier au dernier inclus
 *
 * @param {string} from - Premier jour (YYYY-MM-DD)
 * @param {string|null} to - Dernier jour (YYYY-MM-DD), le premier si absent
 * @returns {Array<string>} - Les jours, au plus MAX_UNAVAILABILITY_DAYS
 */
export const datesBetween = (from, to) => {
  const start = moment(from, 'YYYY-MM-DD');
  const end = to ? moment(to, 'YYYY-MM-DD') : start.clone();
  const dates = [];

  for (
    const day = start.clone();
    !day.isAfter(end) && dates.length < MAX_UNAVAILABILITY_DAYS;
    day.add(1, 'day')
  ) {
    dates.push(day.format('YYYY-MM-DD'));
  }

  return dates;
};
